import type { Property, Agent, BlogPost, Testimonial } from '../types';

export const mockAgents: Agent[] = [
  {
    id: '1',
    name: 'Priya Sharma',
    email: 'priya.sharma@makemypropertyz.com',
    phone: '+91 98765 43210',
    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=face',
    bio: 'Experienced real estate professional with over 8 years in the Bangalore market. Specializes in luxury apartments and commercial properties.',
    specialties: ['Luxury Apartments', 'Commercial Properties', 'Investment Properties'],
    experience: 8,
    rating: 4.9,
    reviewCount: 127,
  },
  {
    id: '2',
    name: 'Rajesh Kumar',
    email: 'rajesh.kumar@makemypropertyz.com',
    phone: '+91 98765 43211',
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face',
    bio: 'Dedicated to helping families find their perfect home in Bangalore. Expert in residential properties and first-time buyer assistance.',
    specialties: ['Residential Properties', 'First-time Buyers', 'Family Homes'],
    experience: 6,
    rating: 4.8,
    reviewCount: 89,
  },
];

export const mockProperties: Property[] = [
  {
    id: '1',
    title: 'Luxury 3BHK Apartment in Koramangala',
    description: 'Stunning modern apartment with premium amenities, located in the heart of Koramangala. Features spacious rooms, modular kitchen, and beautiful city views.',
    price: 18500000,
    location: {
      address: '123 MG Road, Koramangala',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560034',
      latitude: 12.9352,
      longitude: 77.6245,
    },
    details: {
      bedrooms: 3,
      bathrooms: 3,
      sqft: 1850,
      propertyType: 'apartment',
      status: 'for-sale',
      yearBuilt: 2020,
    },
    features: ['Air Conditioning', 'Parking', 'Balcony', 'Furnished', 'Security'],
    amenities: ['Swimming Pool', 'Gym', 'Club House', 'Children\'s Play Area', '24/7 Security'],
    images: [
      {
        id: '1',
        url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&h=800&fit=crop',
        alt: 'Modern apartment exterior',
        isPrimary: true,
        order: 1,
      },
      {
        id: '2',
        url: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&h=800&fit=crop',
        alt: 'Spacious living room',
        isPrimary: false,
        order: 2,
      },
      {
        id: '3',
        url: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&h=800&fit=crop',
        alt: 'Modern kitchen',
        isPrimary: false,
        order: 3,
      },
    ],
    agent: mockAgents[0],
    featured: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
  },
  {
    id: '2',
    title: 'Spacious 4BHK Villa in Whitefield',
    description: 'Beautiful independent villa with garden, perfect for families. Located in a peaceful residential area with excellent connectivity.',
    price: 32000000,
    location: {
      address: '456 Whitefield Main Road',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560066',
      latitude: 12.9698,
      longitude: 77.7500,
    },
    details: {
      bedrooms: 4,
      bathrooms: 4,
      sqft: 2800,
      lotSize: 4000,
      propertyType: 'house',
      status: 'for-sale',
      yearBuilt: 2019,
    },
    features: ['Garden', 'Parking for 2 cars', 'Terrace', 'Servant Room', 'Security'],
    amenities: ['Gated Community', 'Park', 'Community Hall', 'Power Backup'],
    images: [
      {
        id: '4',
        url: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&h=800&fit=crop',
        alt: 'Beautiful villa exterior',
        isPrimary: true,
        order: 1,
      },
      {
        id: '5',
        url: 'https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?w=1200&h=800&fit=crop',
        alt: 'Villa living room',
        isPrimary: false,
        order: 2,
      },
    ],
    agent: mockAgents[1],
    featured: true,
    createdAt: '2024-01-12T10:00:00Z',
    updatedAt: '2024-01-12T10:00:00Z',
  },
  {
    id: '3',
    title: 'Cozy 2BHK Apartment for Rent in HSR Layout',
    description: 'Well-maintained apartment available for rent. Close to metro station and IT parks. Ideal for working professionals.',
    price: 35000,
    location: {
      address: '789 HSR Layout Sector 1',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560102',
      latitude: 12.9082,
      longitude: 77.6476,
    },
    details: {
      bedrooms: 2,
      bathrooms: 2,
      sqft: 1200,
      propertyType: 'apartment',
      status: 'for-rent',
      yearBuilt: 2018,
    },
    features: ['Semi-Furnished', 'Parking', 'Balcony', 'Lift'],
    amenities: ['Gym', 'Security', 'Power Backup', 'Water Supply'],
    images: [
      {
        id: '6',
        url: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=1200&h=800&fit=crop',
        alt: 'Cozy apartment living room',
        isPrimary: true,
        order: 1,
      },
    ],
    agent: mockAgents[0],
    featured: false,
    createdAt: '2024-01-10T10:00:00Z',
    updatedAt: '2024-01-10T10:00:00Z',
  },
];

export const mockBlogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Top 10 Areas to Invest in Bangalore Real Estate 2024',
    slug: 'top-10-areas-invest-bangalore-real-estate-2024',
    excerpt: 'Discover the most promising areas in Bangalore for real estate investment this year. Our comprehensive analysis covers growth potential, infrastructure development, and market trends.',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
    author: {
      name: 'Sneha Reddy',
      photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face',
      bio: 'Real Estate Market Analyst with 10+ years of experience in Bangalore property market.',
    },
    tags: ['Investment', 'Bangalore', 'Market Analysis', 'Real Estate'],
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&h=600&fit=crop',
    publishedAt: '2024-01-20T10:00:00Z',
    updatedAt: '2024-01-20T10:00:00Z',
  },
  {
    id: '2',
    title: 'Guide to Home Loan Process in India',
    slug: 'guide-home-loan-process-india',
    excerpt: 'Everything you need to know about getting a home loan in India. From documentation to approval, we cover the complete process.',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
    author: {
      name: 'Amit Patel',
      photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
      bio: 'Financial Advisor specializing in real estate financing and home loans.',
    },
    tags: ['Home Loan', 'Finance', 'Documentation', 'Banking'],
    image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=1200&h=600&fit=crop',
    publishedAt: '2024-01-18T10:00:00Z',
    updatedAt: '2024-01-18T10:00:00Z',
  },
];

export const mockTestimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Anita Gupta',
    location: 'Koramangala, Bangalore',
    photo: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=400&h=400&fit=crop&crop=face',
    rating: 5,
    text: 'MakeMyPropertyz helped us find our dream home in just 2 weeks! Their team was professional, knowledgeable, and always available to answer our questions.',
    date: '2024-01-15',
  },
  {
    id: '2',
    name: 'Rohan Singh',
    location: 'Whitefield, Bangalore',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
    rating: 5,
    text: 'Excellent service! They understood exactly what we were looking for and showed us properties that matched our requirements perfectly.',
    date: '2024-01-12',
  },
  {
    id: '3',
    name: 'Meera Krishnan',
    location: 'HSR Layout, Bangalore',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face',
    rating: 5,
    text: 'The team at MakeMyPropertyz made the entire home buying process smooth and stress-free. Highly recommended!',
    date: '2024-01-10',
  },
];
